import './index.css'
import { useState } from 'react'
import { LayoutDashboard, List, Plus, BarChart2, User, CreditCard, Target, Settings, LogOut, Shield } from 'lucide-react'
import type { BottomNavProps, NavId } from '../../types'

interface TabItem {
  id: string
  label: string
  Icon: React.ElementType
  fab?: boolean
  you?: boolean
}

const TABS: TabItem[] = [
  { id: 'overview', label: 'Visão',       Icon: LayoutDashboard },
  { id: 'transactions', label: 'Transações', Icon: List },
  { id: 'add',      label: '',            Icon: Plus, fab: true  },
  { id: 'annual',   label: 'Anual',       Icon: BarChart2        },
  { id: 'você',     label: 'Você',        Icon: User, you: true  },
]

const YOU_ITEMS: { id: NavId; label: string; Icon: React.ElementType }[] = [
  { id: 'cards',    label: 'Cartões',     Icon: CreditCard },
  { id: 'goals',    label: 'Metas',       Icon: Target     },
  { id: 'settings', label: 'Configurações', Icon: Settings },
]

export default function BottomNav({ active, onNav, onAdd, onSignOut, isAdmin }: BottomNavProps) {
  const [youOpen, setYouOpen] = useState(false)

  const isYouActive = active === 'cards' || active === 'goals' || active === 'settings'

  function handleTabClick(tab: TabItem) {
    if (tab.fab) { onAdd(); return }
    if (tab.you) { setYouOpen(o => !o); return }
    onNav(tab.id as NavId)
  }

  function handleYouNav(id: NavId) {
    setYouOpen(false)
    onNav(id)
  }

  return (
    <>
      <nav className="bcm-bottomnav" data-tour="bottom-nav">
        {isAdmin ? (
          <>
            <button
              className={'bcm-tab' + (active === 'admin' ? ' is-active' : '')}
              onClick={() => onNav('admin')}
              aria-label="Admin"
            >
              <Shield size={20} />
              <span className="bcm-tab__lbl">Admin</span>
            </button>
            <button
              className="bcm-tab bcm-tab--signout"
              onClick={onSignOut}
              aria-label="Sair"
            >
              <LogOut size={20} />
              <span className="bcm-tab__lbl">Sair</span>
            </button>
          </>
        ) : (
          TABS.map(({ id, label, Icon, fab, you }) => (
            <button
              key={id}
              className={
                'bcm-tab' +
                (fab ? ' is-fab' : '') +
                (!fab && !you && active === id ? ' is-active' : '') +
                (you && isYouActive ? ' is-active' : '')
              }
              onClick={() => handleTabClick({ id, label, Icon, fab, you })}
              data-tour={fab ? 'add-btn-mobile' : undefined}
              aria-label={label || 'Adicionar lançamento'}
              aria-expanded={you ? youOpen : undefined}
            >
              <Icon size={fab ? 22 : 20} />
              {label && <span className="bcm-tab__lbl">{label}</span>}
            </button>
          ))
        )}
      </nav>

      {youOpen && (
        <>
          <div className="bcm-you-overlay" onClick={() => setYouOpen(false)} aria-hidden="true" />
          <div className="bcm-you-sheet" role="dialog" aria-label="Menu Você">
            <div className="bcm-you-handle" />
            {YOU_ITEMS.map(({ id, label, Icon }) => (
              <button
                key={id}
                className="bcm-you-item"
                onClick={() => handleYouNav(id)}
              >
                <Icon size={20} />
                {label}
              </button>
            ))}
            <div className="bcm-you-divider" />
            <button
              className="bcm-you-item bcm-you-item--danger"
              onClick={() => { setYouOpen(false); onSignOut() }}
            >
              <LogOut size={20} />
              Sair
            </button>
          </div>
        </>
      )}
    </>
  )
}
